import { Component, OnDestroy, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormAutoFocusComponent } from '../formautofocus/formAutoFocus.component';
import { Subscription } from 'rxjs'

@Component({
})

export abstract class ValidateComponent extends FormAutoFocusComponent implements AfterViewChecked, OnDestroy {
    validationSub: Subscription;

    validateForm: NgForm;
    abstract currentForm: NgForm;

    dateMask: any = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

    formErrors = {
    };

    validationMessages = {
    };

    ngAfterViewChecked() {
        this.formChanged();
    }

    formChanged() {
        if (this.currentForm === this.validateForm) { return; }
        this.validateForm = this.currentForm;
        if (this.validateForm) {
            if (this.validationSub) this.validationSub.unsubscribe();
            this.validationSub = this.validateForm.valueChanges
                .subscribe(data => this.onValueChanged(data));
        }
    }

    onValueChanged(data?: any) {
        if (!this.validateForm) { return; }
        this.showErrors(false);
    }

    showErrors(negateDirty: boolean): boolean {
        let valid = true;

        const form = this.validateForm.form;
        for (const field in this.formErrors) {
            const control = form.get(field);

            if (control && control.valid) {
                // clear previous error message (if any)
                this.formErrors[field] = '';
            }
            
            if (control && (control.dirty || negateDirty) && control.status !== 'DISABLED' && !control.valid) {
                valid = false;
                const messages = this.validationMessages[field];
                this.formErrors[field] = '';
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }

        return valid;
    }

    removeErrors() {
        for (const field in this.formErrors) {
            this.formErrors[field] = '';
        }

        this.validateForm.form.markAsPristine();
        this.validateForm.form.markAsUntouched();
    }

    ngOnDestroy() {
        if (this.validationSub) this.validationSub.unsubscribe();
    }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/validateComponent/validate.component.ts